/* $(document).ready(function() {
  if(jQuery('.subscription-radio').is(':checked')){
    jQuery('.4-pack').hide();
    //var varient_id_redirect = $(".varient-sub-check:eq(1)").attr('varient-id');
    //var newurl = '?variant='+varient_id_redirect;
    //history.pushState({}, null, newurl);
  }else{
    jQuery('.4-pack').show();
  }
})

$(document).ready(function() {
  jQuery('.subscription-radio').on('click', function(){
    jQuery('.4-pack').hide();
    var variant_id_redirect = $(".wetheme-custom-radio:eq(1)").attr('varient-id');
    var newurl = '?variant='+variant_id_redirect;
    history.pushState({}, null, newurl);  
    jQuery('.8-pack .swatch-element').trigger('click');

  })


  jQuery('.onetime-radio').on('click', function(){
    jQuery('.4-pack').show();
  })

}) */

$(document).ready(function () {
    function updateCartCounter(itemCount) {
        $('.cart-item-count-header--quantity').text(itemCount);
    }

    function getShopifyCart() {
        $.getJSON('/cart.js', function(cart) {
            updateCartCounter(cart.item_count);
        });
    }

    function handleCartUpdated() {
        $(document).on('cart:updated', function() {
            getShopifyCart();
        });
    }

    function handleRebuyCartChange() {
        document.addEventListener('rebuy:cart.change', function(event) {
            let itemCount = event.detail.cart.cart.item_count;
            updateCartCounter(itemCount);
        });
    }

    function init() {
        getShopifyCart();
        handleCartUpdated();
        handleRebuyCartChange();
    }

    init();
});